import React, { Fragment } from "react";
import styled from "styled-components";
import { Route, Link } from "react-router-dom";
import { Button, Grid } from "@material-ui/core";
import { Done, Clear, Reply, AttachFile, InsertDriveFile, Create, ContentCopy } from "@material-ui/icons";

const SectionTitle = styled.div`
  font-size: 24px;
`;
const NewButton = styled(Button)`
  && {
    margin-left: 4px;
    padding: 8px 8px 8px 2px;
    border-radius: 0;
    color: #2196f3;
    background: none;
  }
  &&:hover {
    background: none;
  }
`;
const SnRButton = styled(Button)`
  && {
    margin-left: 4px;
    padding: 8px 8px 8px 2px;
    border-radius: 0;
    color: rgb(255, 255, 255);
    background-color: rgba(0, 157, 223, 1);
  }
  &&:hover {
    background: rgba(0, 157, 223, 1);
  }
`;
const VerticalDivider = styled.div`
  height: 24px;
  border-right: 1px solid #cccccc;
`;
const Container = styled.div`
  padding: 5px;
  border-width: 0px;
  height: 76px;
  background: inherit;
  background-color: rgba(255, 255, 255, 1);
  border: none;
  border-radius: 0px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
`;

const LoanNoteAttachementControlContainer = styled(Grid)`
  max-width:300px;
  min-width:300px;
  float:right;
  margin-right:15px;
`;

const SaveButton = props => (
  <NewButton variant="contained" onClick={props.onClick}>
    <Done />
    SAVE
  </NewButton>
);
const SaveAndReturnButton = props => (
  <SnRButton variant="contained" onClick={props.onClick}>
    <Reply />
    {"SAVE & RETURN"}
  </SnRButton>
);

const CancelButton = props => (
  <NewButton variant="contained" onClick={props.onClick}>
    <Clear />
    CANCEL
  </NewButton>
);
const AttachmentsButton = props => (
  <NewButton variant="contained" onClick={props.onClick}>
    <AttachFile />
    ATTACHMENTS
  </NewButton>
);
const NotesButton = props => (
  <NewButton variant="contained" onClick={props.onClick}>

    <InsertDriveFile />
    NOTES
  </NewButton>
);

const EditButton = props => (
  <NewButton variant="contained" onClick={props.onClick}>
    <Create />
    EDIT QUOTE
  </NewButton>
);

const DuplicateButton = props => (
  <NewButton variant="contained" onClick={props.onClick}>
    <ContentCopy />
    DUPLICATE
  </NewButton>
);

const LoanHeader = props => (
  <Container>
    <Grid container direction="row" justify="flex-start" alignItems="center" spacing={8}>
      <Grid item xs={9}>
        <Grid container direction="row" justify="flex-start" alignItems="center" spacing={8}>
          <Grid item><SectionTitle>Quote Details</SectionTitle></Grid>
          {(!props.authentication.isGuest || (props.authentication.isGuest && props.guestPermissions.canEdit)) ? props.isEditing ? (
            <>
              <Grid item><CancelButton onClick={props.cancel} /></Grid>
              <Grid item><VerticalDivider /></Grid>
              <Grid item><SaveButton onClick={props.saveLoan} /></Grid>
              <Grid item><VerticalDivider /></Grid>
              <Grid item><SaveAndReturnButton onClick={props.saveReturn} /></Grid>
            </>
          ) :
            (
              <Grid item>
                <EditButton onClick={props.editLoan} />
                <DuplicateButton onClick={props.onDuplicate} />
              </Grid>
            ) : null}
        </Grid>
      </Grid>
      <Grid item xs={3}>
        {!props.isNewLoan && (
          <LoanNoteAttachementControlContainer container direction="row" justify="flex-start" alignItems="center" spacing={8}>
            <Grid item><NotesButton onClick={props.openNotes} /></Grid>
            <Grid item><VerticalDivider /></Grid>
            <Grid item><AttachmentsButton onClick={props.openAttachments} /></Grid>
          </LoanNoteAttachementControlContainer>
        )}
      </Grid>
    </Grid>
  </Container>
);

export default LoanHeader;
